import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@material-ui/core";
import { Rating } from "@mui/material";
import NotificationProvider from "components/NotificationProvider";
import RichTextEditor from "components/RichTextEditor/RichTextEditor";
import { useGetVendorByIdQuery } from "features/vendor/vendorSlice";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { vendorFeedbackTypeList, vendorFeedbackTypes } from "../consts";
import { vendorFeedbackStyle } from "./style";
import { useAddFeedbackMutation } from "./vendorFeedbackSlice";
import { VendorRating } from "./VendorRating";
import CustomInput from "../../../components/CustomInput";
import { useGetClientsQuery } from "features/clients/clientSlice";
import { flatten } from "lodash";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";

export const VendorFeedback = ({ vendor, withDialog }) => {

    const vendorId = useParams().id || vendor?.id;

    const classes = vendorFeedbackStyle()
    const [addFeedback, { isLoading: isAdding }] = useAddFeedbackMutation();
    let { data: vendorFromApi, error: vendorError, isLoading: isLoadingVendor } =
        useGetVendorByIdQuery(vendorId, {
            skip: !vendorId,
        });
    let { data: clients, error: clientError, isLoading: isLoadingClients } = useGetClientsQuery(null);
    let clientAccounts = flatten(clients?.map(c => c.clientAccounts));

    const defaultRating = 0;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [feedbackText, setFeedbackText] = useState()
    const [clientAccountId, setClientAccountId] = useState()

    const [rating, setRating] = useState({
        [vendorFeedbackTypes.Quality]: defaultRating,
        [vendorFeedbackTypes.Communication]: defaultRating,
        [vendorFeedbackTypes.Value]: defaultRating,
        [vendorFeedbackTypes.CustomerExperience]: defaultRating,
        [vendorFeedbackTypes.OverallSatisfaction]: defaultRating,
    });

    const [notes, setNotes] = useState({
        [vendorFeedbackTypes.Quality]: '',
        [vendorFeedbackTypes.Communication]: '',
        [vendorFeedbackTypes.Value]: '',
        [vendorFeedbackTypes.CustomerExperience]: '',
        [vendorFeedbackTypes.OverallSatisfaction]: '',
    });

    const onSave = async () => {
        const res = await addFeedback({
            vendorId,
            feedbackText,
            clientAccountId,
            feedbackItems: Object.entries(rating)?.map(([key, value]) => ({
                feedbackType: +key,
                rating: value,
                feedbackText: notes[key] || '',
            })),
        })
        if (res && !res.error) {
            NotificationProvider.success("Feedback submitted successfully");
            reset();
        } else {
            NotificationProvider.error("Failed to submit feedback");
        }
    }

    const onChangeRating = (feedbackType, value) => {
        setRating((prevRatings) => ({
            ...prevRatings,
            [feedbackType]: value,
        }));
    };

    const onChangeNote = (feedbackType, value) => {
        setNotes((prevRatings) => ({
            ...prevRatings,
            [feedbackType]: value,
        }));
    };

    const onChangeFeedbackText = (value) => {
        setFeedbackText(value)
    };

    const reset = () => {
        setRating({
            [vendorFeedbackTypes.Quality]: defaultRating,
            [vendorFeedbackTypes.Communication]: defaultRating,
            [vendorFeedbackTypes.Value]: defaultRating,
            [vendorFeedbackTypes.CustomerExperience]: defaultRating,
            [vendorFeedbackTypes.OverallSatisfaction]: defaultRating,
        });
        setNotes({
            [vendorFeedbackTypes.Quality]: '',
            [vendorFeedbackTypes.Communication]: '',
            [vendorFeedbackTypes.Value]: '',
            [vendorFeedbackTypes.CustomerExperience]: '',
            [vendorFeedbackTypes.OverallSatisfaction]: '',
        });

    }
    useEffect(() => {
        reset();
    }, [vendorId]);

    const content = <div className={classes.container}>
        <div className={classes.subTitle}>Rate your experience with this vendor</div>
        <h3>{vendorFromApi?.name}</h3>
        {clientAccounts?.length > 1 && <>
            <div className={classes.description}>Select the client that was serviced (optional)</div>
            <CustomInput
                id="clientAccountId"
                label="Client"
                value={clientAccountId}
                elementType="dropdown"
                onChange={(val) => {
                    setClientAccountId(val)
                }}
                values={clientAccounts}
                showEmpty
                touched
            /></>}

        <RichTextEditor
            style={{ border: '1px solid #ccc', backgroundColor: '#f9f9f9', marginTop: '10px' }}
            withToolbar={false}
            onChange={(val) => onChangeFeedbackText(val)}
            content={feedbackText ? feedbackText : ''}
        />
        {vendorFeedbackTypeList.map((feedbackType) => (
            <div key={feedbackType.key}>
                <Grid container alignItems="center" justifyContent="space-between" >
                    <Grid item className={classes.feedbackTypeLabel}> {feedbackType.label}</Grid>
                </Grid>

                <div className={classes.description}>{feedbackType.description}</div>
                <div className={classes.scaleDescription}>{feedbackType.scaleDescription}</div>
                <VendorRating
                    feedbackType={feedbackType.key}
                    value={rating[feedbackType.key]}
                    onChange={(event, newValue) => {
                        onChangeRating(feedbackType.key, newValue);
                    }}
                />
                <RichTextEditor
                    style={{ border: '1px solid #ccc', backgroundColor: '#f9f9f9', marginTop: '10px' }}
                    withToolbar={false}
                    onChange={(val) => onChangeNote(feedbackType.key, val)}
                    content={notes[feedbackType.key] ? notes[feedbackType.key] : ''}
                />
            </div >
        ))}

    </div >;
    const buttons = <Button onClick={onSave}
        disabled={isAdding}
        variant="contained"
        color="primary"
        className={classes.saveButton}>
        {isAdding ? 'Saving...' : 'Save Feedback'}
    </Button>
    return (
        <>
            {withDialog ? <><Authorize profile={permissionProfiles.VENDOR.ADD_FEEDBACK}>
                <Button
                    variant="text"
                    color="primary"
                    onClick={() => {
                        setDialogOpen(true);
                    }}>Send Feedback</Button>
            </Authorize>
                <Dialog open={dialogOpen}
                    onClose={() => setDialogOpen(false)} maxWidth="md" fullWidth>
                    <DialogTitle>Vendor Feedback</DialogTitle>
                    <DialogContent>
                        {content}
                    </DialogContent>
                    <DialogActions>
                        {buttons}
                    </DialogActions>
                </Dialog></> : <>{content}{buttons}</>}
        </>
    );
}
